import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';

import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

import { AuthenticationService } from '@core/services/auth.service';
import { EtagService } from '@core/services/etag.service';

import { environment } from '@environment/environment';

declare global {
  interface Window {
    Produktly: any; // You can specify a more specific type here if needed
  }
}
@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, FormsModule, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [MessageService],
})
export class AppComponent {
  etagSub: any;
  private updateMessageShown = false;
  constructor(
    private authService: AuthenticationService,
    private cookieService: CookieService,
    private router: Router,
    private messageService: MessageService,
    private etagService: EtagService
  ) {
    if (environment.production) {
      if (this.authService.isLoggedIn) {
        if (window.Produktly) {
          window.Produktly.configure({
            redirect: (url: string) => {
              // Use Angular's Router to navigate without a full page reload
              this.router.navigateByUrl(url);
            },
          });
        }
        if (window.Produktly) {
          this.identifyUser();
        } else {
          window.onload = () => {
            this.identifyUser();
          };
        }
      }
    }
  }
  onVisibilityChange = () => {
    if (document.hidden) {
      document.title = '👋 Come Back!!!';
    } else {
      document.title = 'Confe - Simplify Social Media Management';
    }
  };

  ngOnInit() {
    this.etagSub = this.etagService.etagChanged$.subscribe(() => {
      if (!this.updateMessageShown) {
        this.updateMessageShown = true;
        this.messageService.add({
          key: 'global',
          sticky: true,
          severity: 'warn',
          summary: 'The app has been updated. Please refresh.',
        });
      }
    });
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  ngOnDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.etagSub.unsubscribe();
  }

  identifyUser() {
    const user: any = this.cookieService.get('user');
    const userId = JSON.parse(user).uid;
    const metadata = {};
    window.Produktly.identifyUser(userId, metadata);
  }

  refreshApp() {
    window.location.reload();
  }
}
